import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface ViewState {
  isSimpleView: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ViewStateService {
  private readonly STORAGE_KEY = 'viewState';
  
  private viewStateSubject = new BehaviorSubject<ViewState>({
    isSimpleView: false
  });

  constructor() {
    // Load saved view state from localStorage
    this.loadViewState();
  }

  get viewState$(): Observable<ViewState> {
    return this.viewStateSubject.asObservable();
  }

  get isSimpleView(): boolean {
    return this.viewStateSubject.value.isSimpleView;
  }

  toggleView(): void {
    const currentState = this.viewStateSubject.value;
    const newState: ViewState = {
      ...currentState,
      isSimpleView: !currentState.isSimpleView
    };
    
    this.viewStateSubject.next(newState);
    this.saveViewState(newState);
  }

  setSimpleView(isSimple: boolean): void {
    const currentState = this.viewStateSubject.value;
    if (currentState.isSimpleView !== isSimple) {
      const newState: ViewState = {
        ...currentState,
        isSimpleView: isSimple
      };
      
      this.viewStateSubject.next(newState);
      this.saveViewState(newState);
    }
  }

  private loadViewState(): void {
    try {
      const savedState = localStorage.getItem(this.STORAGE_KEY);
      if (savedState) {
        const viewState: ViewState = JSON.parse(savedState);
        this.viewStateSubject.next(viewState);
      }
    } catch (error) {
      console.warn('Failed to load view state from localStorage:', error);
    }
  }

  private saveViewState(state: ViewState): void {
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(state));
    } catch (error) {
      console.warn('Failed to save view state to localStorage:', error);
    }
  }
}